import React, {useState} from 'react';
import {connect} from 'react-redux';
import {Form} from 'react-bootstrap';
import Layout from '~/Components/Layout/Layout';
import InvitationStatus from '~/Components/InvitationStatus/InvitationStatus';
import ConfirmedButton from '~/Components/ConfirmedButton/ConfirmedButton';
import {Link} from "react-router-dom";
import {declineInvitationAction} from '~/redux/actions/invitation'
import {declineReasons} from '~/helpers/dictionary'

import './decline.scss';
import ValidationError from "~/Components/Forms/ValidationError";
import ToggleSwitch from '../../Components/ToggleSwitch/ToggleSwitch';
import Translate from "~/Components/ContentTranslate/Translate";
import TextTranslate, { TextTranslateString } from '../../Components/TextTranslate/TextTranslate';

const RsvpDecline = (props) => {

    const [reason, setReason] = useState('');
    const [otherReason, setOtherReason] = useState('');
    const [future, setFuture] = useState(true);
    const [error, setError] = useState(null);

    const handleDecline = () => {

        let promise = props.dispatch(declineInvitationAction(props.invitation.id, reason, otherReason, future));

        promise.then((data) => {
            setError(null);
        }).catch((error) => {
            setError(error.response?.data);
        });
    };

    if (!props.invitation) {
        return <></>;
    }

    if (props.invitation.rsvp_status === 'declined') {
        return (
            <Layout narrow colorBg cardBorder>
                <div className="container-decline px-0">
                    <div className="row">
                        <div className="container-decline__main col-12">
                            <h1 className="font-weight-normal">
                                <TextTranslate name="attendance-declined-title" fallback="Invitation declined" textOnly/>
                            </h1>
                            <p>
                                <TextTranslate name="attendance-declined-note" fallback="Thank you for confirming that you will not be joining our experience at the"/> <Translate model={props.invitation.event} field="name" />.
                                <TextTranslate name="attendance-declined-note-1" fallback="We are sorry to hear that you can't be with us."/>
                            </p>
                            <p>
                                <TextTranslate name="attendance-declined-questions-note"/>
                            </p>
                            <Link className="btn btn-primary" to="/"><TextTranslate name="word-return-home" fallback="Return Home" textOnly/></Link>
                        </div>
                    </div>
                </div>
            </Layout>
        );
    }

    return (
        <Layout narrow colorBg cardBorder>
            <div className="container-decline container-decline--form">
                <div className="row">
                    <div className="head col-12">
                        <h1>
                            <TextTranslate name="attendance-decline-title" fallback="Decline your invitation" textOnly/>
                        </h1>
                        <p>
                            <TextTranslate name="attendance-decline-note" textOnly/> <Translate model={props.invitation.event} field="name" />. <TextTranslate name="attendance-decline-note-1" fallback="We are sorry to hear that you can’t be with us." textOnly/>
                        </p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <InvitationStatus selected="no"/>
                    </div>
                </div>
                <hr/>
                <div className="row">
                    <div className="col-12">
                        <h3>
                            <TextTranslate name="attendance-decline-reasons-title" fallback="Reasons for declining" textOnly/>
                        </h3>
                        <p>
                            <TextTranslate name="attendance-decline-reasons-note" fallback="To help us better understand why you are unable to attend, please select the relevant option below." textOnly/>
                        </p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <div className="form-group mb-0">

                            {error?.message && (
                                <div className="alert alert-danger" role="alert">
                                    {error.message}
                                </div>
                            )}

                            <p className="text-uppercase text-color-gray text-caption font-weight-500 mb-1">
                                <TextTranslate name="tick-relevant-reason" fallback="Please tick the relevant option" textOnly/>
                            </p>

                            {Object.entries(declineReasons).map((row) => {
                                return (
                                    <Form.Check
                                        onChange={e => setReason(row[0])}
                                        type="radio"
                                        label={ TextTranslateString(`decline-reason-${row[0]}`, 'Cannot find translation', props.currentLanguage, props.translations) }
                                        name="reason"
                                        key={row[0]}
                                        id={row[0]}
                                    />
                                );
                            })}

                            {reason === 'other' && (
                                <>
                                    <input type="text"
                                           value={otherReason}
                                           onChange={e => setOtherReason(e.target.value)}
                                           className="form-control"
                                           name="other_reason"
                                    />

                                    <ValidationError errors={error?.errors} name="other_reason" />
                                </>
                            )}

                            <ValidationError errors={error?.errors} name="reason" />
                        </div>
                    </div>
                </div>
                <hr />
                <div className="row">
                    <div className="col-12">
                        <h3>
                            <TextTranslate name="attendance-decline-future-experiences" fallback="Future experiences" textOnly/>
                        </h3>
                        <p>
                            <TextTranslate name="attendance-decline-future-experiences-note" fallback="Please indicate whether you would like to be considered for future NEOM experiences." textOnly/>
                        </p>
                        <ToggleSwitch
                            textClasses="text-uppercase font-weight-500 text-color-gray"
                            label1={TextTranslateString('word-no', 'No', props.currentLanguage, props.translations)}
                            label2={TextTranslateString('word-yes', 'Yes', props.currentLanguage, props.translations)}
                            onChange={e => {setFuture(!future)}}
                            isChecked={future}
                            id="decline-future-experiences"
                        />
                    </div>
                </div>
                <div className="actions flex-gap">
                    <ConfirmedButton
                        confirmTitle={<TextTranslate name="modal-please-confirm" fallback="Please Confirm" textOnly/>}
                        confirmText={<TextTranslate name="modal-decline-confirmation-msg" fallback='Are you sure you want to decline ?' textOnly/>}
                        onClick={handleDecline}
                        className="btn btn-primary">
                        <TextTranslate name="word-confirm-rsvp" fallback="Confirm RSVP" textOnly/>
                    </ConfirmedButton>
                    <Link className="btn btn-secondary" to="/invitation">
                        <TextTranslate name="word-cancel" fallback="Cancel" textOnly/>
                    </Link>
                </div>
            </div>
        </Layout>
    );
}

const mapStateToProps = (state) => ({
    currentLanguage: state.translations?.currentLanguage,
	translations: state.translations?.translations,
    auth: state.auth.auth,
    invitation: state.invitation.data,
});

export default connect(mapStateToProps)(RsvpDecline);
